import * as MD from '@material-ui/core';
import * as React from 'react';
import { connect } from 'react-redux';
import { Autocomplete, AutocompleteRenderInputParams } from '@material-ui/lab/';

import { RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';
import { IApplicationState, IConnectedReduxProps } from '../../../../../Store';
import {
	getAllMedias,
	resetMedias,
	getGroupsAndUsersFromChannelTPP,
	addUserChannelsTPP,
	addGroupChannelsTPP,
} from '../../../../../Store/AppsManagement/Actions';
import { IAppsManagementState } from '../../../../../Store/AppsManagement/Types';
import { I18N } from '../../../../../Store/I18n/Types';
import { IUserState } from '../../../../../Store/User/Types';
import {
	IUserManagementState,
	IUserSearchParams,
	IUserSearchParamsSorting,
	UserACL,
} from '../../../../../Store/UserManagement/Types';
import { getTheme } from '../../../../../Themes';
import {
	getACLParents,
	getACLUsers,
} from '../../../../../Store/UserManagement/Actions';
import {
	isNullOrUndefined,
	isNullOrUndefinedOrEmptyString,
} from '../../../../../Utils/Various';

export interface IRouterMatchParams {
	groupName: string;
	type: string;
}

interface IPropsFromState {
	i18n: I18N;
	router: RouteComponentProps<IRouterMatchParams>;
	user: IUserState;
	appsManagement: IAppsManagementState;
	userManagement: IUserManagementState;
}

interface IState {
	mode: number;
	addedUsers: UserACL[];
	addedGroups: UserACL[];
}

interface IPropsFromDispatch {
	getACLUsers: typeof getACLUsers;
	getACLParents: typeof getACLParents;
	getAllMedias: typeof getAllMedias;
	getGroupsAndUsersFromChannelTPP: typeof getGroupsAndUsersFromChannelTPP;
	resetMedias: typeof resetMedias;
	addGroupChannelsTPP: typeof addGroupChannelsTPP;
	addUserChannelsTPP: typeof addUserChannelsTPP;
}

const theme = getTheme();

const styles = MD.createStyles({
	row: {
		'& > *': {
			borderBottom: 'unset',
		},
	},
	table: {
		minWidth: 750,
	},
	margin: {
		margin: theme.spacing(1),
	},
	noResult: {
		textAlign: 'center',
		fontSize: 'large',
	},
	smallIcon: {
		padding: '3px',
	},
	cell5: {
		width: '5%',
	},
	cell125: {
		width: '12.5%',
	},
	cell15: {
		width: '15%',
	},
	cell20: {
		width: '20%',
	},
});

type AllProps = MD.WithStyles<typeof styles> &
	IPropsFromState &
	IPropsFromDispatch &
	RouteComponentProps<{}> &
	IConnectedReduxProps;

/*
 X-Yacast-OrderBy : [name, id]
 X-Yacast-OrderDesc: [true, false]
 X-Yacast-FilterBy-Encoding: [true, false]
 X-Yacast-FilterBy-Type: [1,2,3,4,10] ici seulement 1&2
 */

export class UsersAndGroupsFromChannelComponent extends React.Component<
	AllProps,
	IState
> {
	public constructor(props: AllProps) {
		super(props);
		this.state = {
			mode: 0,
			addedGroups: [],
			addedUsers: [],
		};
	}

	public componentDidMount() {
		if (this.props.router.match.params.groupName !== undefined) {
			if (this.props.router.match.params.groupName !== 'undefined') {
				this.props.getGroupsAndUsersFromChannelTPP(
					parseInt(this.props.router.match.params.groupName, 10),
					this.props.user.token
				);
			}
		}
		this.props.getACLParents(this.props.user.token, '');
		this.props.getACLUsers(
			this.props.user.token,
			{
				isGroup: false,
				researchText: '',
				showInactive: false,
				usersParentID: 0,
			},
			null
		);
	}

	componentWillUnmount() {}

	public render(): React.ReactNode {
		return (
			<React.Fragment>
				<MD.Tabs
					onChange={this.handleTabs.bind(this)}
					value={this.state.mode}
					indicatorColor="primary"
					textColor="primary"
				>
					<MD.Tab label={this.props.i18n._('Users')} />
					<MD.Tab label={this.props.i18n._('Groups')} />
					<MD.Tab label={this.props.i18n._('Add users')} />
					<MD.Tab label={this.props.i18n._('Add groups')} />
				</MD.Tabs>
				<this.TabPanel value={this.state.mode} index={0}>
					{this.renderUsers()}
				</this.TabPanel>
				<this.TabPanel value={this.state.mode} index={1}>
					{this.renderGroups()}
				</this.TabPanel>
				<this.TabPanel value={this.state.mode} index={2}>
					{this.renderAddUsers()}
				</this.TabPanel>
				<this.TabPanel value={this.state.mode} index={3}>
					{this.renderAddGroups()}
				</this.TabPanel>
			</React.Fragment>
		);
	}

	private TabPanel(props: any): JSX.Element {
		const { children, value, index } = props;
		return <div>{value === index && <div>{children}</div>}</div>;
	}

	private handleTabs(e: React.ChangeEvent<{}>, val: number) {
		switch (val.toString(10)) {
			case '0':
				this.setState({ mode: 0 });
				break;
			case '1':
				this.setState({ mode: 1 });
				break;
			case '2':
				this.setState({ mode: 2 });
				break;
			case '3':
				this.setState({ mode: 3 });
				break;
			default:
				this.setState({ mode: 0 });
		}
	}

	private renderUsers(): React.ReactNode {
		const classes = this.props.classes;
		return (
			<React.Fragment>
				{this.props.appsManagement.loadingChannelGroupsAndUser ? (
					<div style={{ paddingTop: 30 }}>
						{this.props.i18n._('Loading')}...
					</div>
				) : (
					<>
						<MD.TableContainer component={MD.Paper}>
							<MD.Table
								aria-label="collapsible table"
								size="small"
							>
								<MD.TableHead>
									<MD.TableRow id="tablerowuser">
										<MD.TableCell
											className={classes.cell125}
										/>
										<MD.TableCell
											className={classes.cell125}
											align="left"
										>
											{this.props.i18n._('ID')}
										</MD.TableCell>
										<MD.TableCell
											className={classes.cell125}
											align="left"
										>
											{this.props.i18n._('Name')}
										</MD.TableCell>
										<MD.TableCell
											className={classes.cell125}
											align="left"
										>
											{this.props.i18n._('Firstname')}
										</MD.TableCell>
										<MD.TableCell
											className={classes.cell125}
											align="left"
										>
											{this.props.i18n._('Username')}
										</MD.TableCell>
										<MD.TableCell
											className={classes.cell125}
											align="left"
										>
											{this.props.i18n._('Groups')}
										</MD.TableCell>
										<MD.TableCell
											className={classes.cell125}
											align="left"
										>
											{this.props.i18n._(
												'Remove channel'
											)}
										</MD.TableCell>
										<MD.TableCell
											className={classes.cell125}
										>
											{this.props.i18n._(
												'Fetch all user channels'
											)}
										</MD.TableCell>
									</MD.TableRow>
								</MD.TableHead>
								{this.displayTableBodyUsers()}
							</MD.Table>
						</MD.TableContainer>
					</>
				)}
			</React.Fragment>
		);
	}
	private renderGroups(): React.ReactNode {
		const classes = this.props.classes;
		return (
			<React.Fragment>
				{this.props.appsManagement.loadingChannelGroupsAndUser ? (
					<div style={{ paddingTop: 30 }}>
						{this.props.i18n._('Loading')}...
					</div>
				) : (
					<>
						<MD.TableContainer component={MD.Paper}>
							<MD.Table
								aria-label="collapsible table"
								size="small"
							>
								<MD.TableHead>
									<MD.TableRow id="tablerowuser">
										<MD.TableCell
											className={classes.cell125}
										/>
										<MD.TableCell
											className={classes.cell125}
											align="left"
										>
											{this.props.i18n._('ID')}
										</MD.TableCell>
										<MD.TableCell
											className={classes.cell125}
											align="left"
										>
											{this.props.i18n._('Name')}
										</MD.TableCell>
										<MD.TableCell
											className={classes.cell125}
											align="left"
										>
											{this.props.i18n._('Firstname')}
										</MD.TableCell>
										<MD.TableCell
											className={classes.cell125}
											align="left"
										>
											{this.props.i18n._('Username')}
										</MD.TableCell>
										<MD.TableCell
											className={classes.cell125}
											align="left"
										>
											{this.props.i18n._(
												'Remove channel'
											)}
										</MD.TableCell>
										<MD.TableCell
											className={classes.cell125}
											align="left"
										>
											{this.props.i18n._(
												'Fetch all group channels'
											)}
										</MD.TableCell>
										<MD.TableCell
											className={classes.cell125}
										></MD.TableCell>
									</MD.TableRow>
								</MD.TableHead>
								{this.displayTableBodyGroups()}
							</MD.Table>
						</MD.TableContainer>
					</>
				)}
			</React.Fragment>
		);
	}
	private renderAddUsers(): React.ReactNode {
		const classes = this.props.classes;
		return (
			<React.Fragment>
				<MD.TableContainer component={MD.Paper}>
					<MD.Table aria-label="collapsible table" size="small">
						<MD.TableHead>
							<MD.TableRow id="tablerowuser">
								<MD.TableCell className={classes.cell125} />
								<MD.TableCell
									className={classes.cell125}
									align="left"
								>
									{this.props.i18n._('ID')}
								</MD.TableCell>
								<MD.TableCell
									className={classes.cell125}
									align="left"
								>
									{this.props.i18n._('Name')}
								</MD.TableCell>
								<MD.TableCell
									className={classes.cell125}
									align="left"
								>
									{this.props.i18n._('Firstname')}
								</MD.TableCell>
								<MD.TableCell
									className={classes.cell125}
									align="left"
								>
									{this.props.i18n._('Username')}
								</MD.TableCell>
								<MD.TableCell
									className={classes.cell125}
									align="left"
								>
									{this.props.i18n._('Groups')}
								</MD.TableCell>
								<MD.TableCell
									className={classes.cell125}
									align="left"
								>
									{this.props.i18n._('Remove')}
								</MD.TableCell>
								<MD.TableCell
									className={classes.cell125}
								></MD.TableCell>
							</MD.TableRow>
						</MD.TableHead>
						{this.displayTableBodyAddUsers()}
					</MD.Table>
				</MD.TableContainer>
				{this.generateAddRowUsers()}
			</React.Fragment>
		);
	}
	private renderAddGroups(): React.ReactNode {
		const classes = this.props.classes;
		return (
			<React.Fragment>
				<MD.TableContainer component={MD.Paper}>
					<MD.Table aria-label="collapsible table" size="small">
						<MD.TableHead>
							<MD.TableRow id="tablerowuser">
								<MD.TableCell className={classes.cell125} />
								<MD.TableCell
									className={classes.cell125}
									align="left"
								>
									{this.props.i18n._('ID')}
								</MD.TableCell>
								<MD.TableCell
									className={classes.cell125}
									align="left"
								>
									{this.props.i18n._('Name')}
								</MD.TableCell>
								<MD.TableCell
									className={classes.cell125}
									align="left"
								>
									{this.props.i18n._('Firstname')}
								</MD.TableCell>
								<MD.TableCell
									className={classes.cell125}
									align="left"
								>
									{this.props.i18n._('Username')}
								</MD.TableCell>
								<MD.TableCell
									className={classes.cell125}
									align="left"
								>
									{this.props.i18n._('Remove')}
								</MD.TableCell>
								<MD.TableCell
									className={classes.cell125}
									align="left"
								></MD.TableCell>
								<MD.TableCell
									className={classes.cell125}
								></MD.TableCell>
							</MD.TableRow>
						</MD.TableHead>
						{this.displayTableBodyAddGroups()}
					</MD.Table>
				</MD.TableContainer>
				{this.generateAddRowGroups()}
			</React.Fragment>
		);
	}

	private generateAddRowUsers() {
		return (
			<React.Fragment>
				<MD.Button
					color="primary"
					variant="contained"
					onClick={() => {
						const addedUsers = this.state.addedUsers;
						const newUser = this.getEmptyUser();
						addedUsers.push(newUser);
						this.setState({ addedUsers });
					}}
				>
					{this.props.i18n._('Add user')}
				</MD.Button>
				<MD.Button
					color="primary"
					variant="contained"
					onClick={() => {
						let addedUsers = this.state.addedUsers;
						for (const key in addedUsers) {
							if (
								Object.prototype.hasOwnProperty.call(
									addedUsers,
									key
								)
							) {
								const user = addedUsers[key];
								if (user.id !== 0) {
									this.props.addUserChannelsTPP(
										[
											parseInt(
												this.props.router.match.params
													.groupName,
												10
											),
										],
										user.id
									);
								}
							}
						}
						addedUsers = [];
						this.setState({ addedUsers });
					}}
				>
					{this.props.i18n._('Update')}
				</MD.Button>
			</React.Fragment>
		);
	}

	private generateAddRowGroups() {
		return (
			<React.Fragment>
				<MD.Button
					color="primary"
					variant="contained"
					onClick={() => {
						const addedGroups = this.state.addedGroups;
						const newUser = this.getEmptyUser();
						addedGroups.push(newUser);
						this.setState({ addedGroups });
					}}
				>
					{this.props.i18n._('Add group')}
				</MD.Button>
				<MD.Button
					color="primary"
					variant="contained"
					onClick={() => {
						let addedGroups = this.state.addedGroups;

						for (const key in addedGroups) {
							if (
								Object.prototype.hasOwnProperty.call(
									addedGroups,
									key
								)
							) {
								const user = addedGroups[key];
								if (user.id !== 0) {
									this.props.addGroupChannelsTPP(
										[
											parseInt(
												this.props.router.match.params
													.groupName,
												10
											),
										],
										user.id
									);
								}
							}
						}

						addedGroups = [];
						this.setState({ addedGroups });
					}}
				>
					{this.props.i18n._('Update')}
				</MD.Button>
			</React.Fragment>
		);
	}

	private getEmptyUser(): UserACL {
		return {
			date_creation: '',
			date_debut: '',
			date_expire: '',
			email: '',
			firstname: '',
			id: 0,
			isactive: true,
			isgroup: false,
			language: 'French',
			localisation: ['FR'],
			name: '',
			parent: {
				email: '',
				id: 0,
				isactive: true,
				name: '',
				username: '',
				isgroup: true,
			},
			phone: '',
			position: '',
			username: '',
		};
	}

	private getPossibleGroups(): UserACL[] {
		const parents = [...this.props.userManagement.parentsACLData];
		return parents;
	}
	private getPossibleUsers(): UserACL[] {
		const parents = [...this.props.userManagement.usersACLData];
		return parents;
	}

	private displayTableBodyUsers(): React.ReactNode | string {
		const classes = this.props.classes;

		if (this.props.appsManagement.channelUsers.length !== 0) {
			return (
				<MD.TableBody>
					{this.props.appsManagement.channelUsers.map((u, i) =>
						this.generateRowUser(u, i)
					)}
				</MD.TableBody>
			);
		} else {
			return (
				<MD.TableBody>
					<MD.TableRow>
						<MD.TableCell colSpan={8} className={classes.noResult}>
							No result
						</MD.TableCell>
					</MD.TableRow>
				</MD.TableBody>
			);
		}
	}
	private displayTableBodyGroups(): React.ReactNode | string {
		const classes = this.props.classes;

		if (this.props.appsManagement.channelGroups.length !== 0) {
			return (
				<MD.TableBody>
					{this.props.appsManagement.channelGroups.map((u, i) =>
						this.generateRowGroup(u, i)
					)}
				</MD.TableBody>
			);
		} else {
			return (
				<MD.TableBody>
					<MD.TableRow>
						<MD.TableCell colSpan={8} className={classes.noResult}>
							No result
						</MD.TableCell>
					</MD.TableRow>
				</MD.TableBody>
			);
		}
	}
	private displayTableBodyAddUsers(): React.ReactNode {
		const classes = this.props.classes;

		if (this.state.addedUsers.length !== 0) {
			return (
				<MD.TableBody>
					{this.state.addedUsers.map((u, i) =>
						this.generateRowAddedUsers(u, i)
					)}
				</MD.TableBody>
			);
		} else {
			return (
				<MD.TableBody>
					<MD.TableRow>
						<MD.TableCell colSpan={8} className={classes.noResult}>
							Waiting new users
						</MD.TableCell>
					</MD.TableRow>
				</MD.TableBody>
			);
		}
	}
	private displayTableBodyAddGroups(): React.ReactNode {
		const classes = this.props.classes;

		if (this.state.addedGroups.length !== 0) {
			return (
				<MD.TableBody>
					{this.state.addedGroups.map((u, i) =>
						this.generateRowAddedGroups(u, i)
					)}
				</MD.TableBody>
			);
		} else {
			return (
				<MD.TableBody>
					<MD.TableRow>
						<MD.TableCell colSpan={8} className={classes.noResult}>
							Waiting new groups
						</MD.TableCell>
					</MD.TableRow>
				</MD.TableBody>
			);
		}
	}

	private generateRowAddedUsers(user: UserACL, i: number): React.ReactNode {
		const classes = this.props.classes;

		return (
			<React.Fragment key={i}>
				<MD.TableRow className={classes.row}>
					<MD.TableCell>
						<Autocomplete
							id="combo-box-parent"
							options={this.getPossibleUsers()}
							onChange={(ev: React.ChangeEvent<{}>, val: any) => {
								if (
									!isNullOrUndefined(val) &&
									!isNullOrUndefinedOrEmptyString(
										val.username
									)
								) {
									this.updateUsersInformation(i, val);
								}
							}}
							getOptionLabel={(option) => option.username}
							renderInput={(
								params: AutocompleteRenderInputParams
							) => (
								<MD.TextField
									{...params}
									label={this.props.i18n._('User')}
									value={user.username}
									onChange={(event: any) => {
										this.props.getACLUsers(
											this.props.user.token,
											{
												isGroup: false,
												researchText:
													event.target.value,
												showInactive: false,
												usersParentID: 0,
											},
											null
										);
									}}
								/>
							)}
						/>
					</MD.TableCell>
					<MD.TableCell component="th" scope="row">
						{user.id}
					</MD.TableCell>
					<MD.TableCell align="left">{user.name}</MD.TableCell>
					<MD.TableCell align="left">{user.firstname}</MD.TableCell>
					<MD.TableCell align="left">{user.username}</MD.TableCell>
					<MD.TableCell align="left">{user.parent.name}</MD.TableCell>
					<MD.TableCell align="left">
						<MD.Button
							color="primary"
							aria-label="rights picture"
							component="span"
							onClick={(
								event: React.MouseEvent<
									HTMLButtonElement,
									MouseEvent
								>
							) => {
								this.removeUsersInformation(user);
							}}
						>
							{this.props.i18n._('Remove')}
						</MD.Button>
					</MD.TableCell>
					<MD.TableCell align="left"></MD.TableCell>
				</MD.TableRow>
			</React.Fragment>
		);
	}

	private generateRowAddedGroups(group: UserACL, i: number): React.ReactNode {
		const classes = this.props.classes;

		return (
			<React.Fragment key={i}>
				<MD.TableRow className={classes.row}>
					<MD.TableCell>
						<Autocomplete
							id="combo-box-parent"
							options={this.getPossibleGroups()}
							onChange={(ev: React.ChangeEvent<{}>, val: any) => {
								if (
									!isNullOrUndefined(val) &&
									!isNullOrUndefinedOrEmptyString(val.name)
								) {
									this.updateGroupsInformation(i, val);
								}
							}}
							getOptionLabel={(option) => option.name}
							renderInput={(
								params: AutocompleteRenderInputParams
							) => (
								<MD.TextField
									{...params}
									label={this.props.i18n._('Group')}
									value={group.username}
									onChange={(event: any) => {
										this.props.getACLParents(
											this.props.user.token,
											event.target.value
										);
									}}
								/>
							)}
						/>
					</MD.TableCell>
					<MD.TableCell component="th" scope="row">
						{group.id}
					</MD.TableCell>
					<MD.TableCell align="left">{group.name}</MD.TableCell>
					<MD.TableCell align="left">{group.firstname}</MD.TableCell>
					<MD.TableCell align="left">{group.username}</MD.TableCell>
					<MD.TableCell align="left">
						<MD.Button
							color="primary"
							aria-label="rights picture"
							component="span"
							onClick={(
								event: React.MouseEvent<
									HTMLButtonElement,
									MouseEvent
								>
							) => {
								this.removeGroupsInformation(group);
							}}
						>
							{this.props.i18n._('Remove')}
						</MD.Button>
					</MD.TableCell>
					<MD.TableCell align="left"></MD.TableCell>
				</MD.TableRow>
			</React.Fragment>
		);
	}

	private removeGroupsInformation(grouptoremove: UserACL) {
		const addedGroups: UserACL[] = [];
		const array = this.state.addedGroups;
		for (const key in array) {
			if (Object.prototype.hasOwnProperty.call(array, key)) {
				const element = array[key];
				if (element !== grouptoremove) {
					addedGroups.push(element);
				}
			}
		}
		this.setState({ addedGroups });
	}
	private removeUsersInformation(usertoremove: UserACL) {
		const addedUsers: UserACL[] = [];
		const array = this.state.addedUsers;
		for (const key in array) {
			if (Object.prototype.hasOwnProperty.call(array, key)) {
				const element = array[key];
				if (element !== usertoremove) {
					addedUsers.push(element);
				}
			}
		}
		this.setState({ addedUsers });
	}

	private generateRowUser(user: UserACL, i: number): React.ReactNode {
		const classes = this.props.classes;

		return (
			<React.Fragment key={i}>
				<MD.TableRow className={classes.row}>
					<MD.TableCell></MD.TableCell>
					<MD.TableCell component="th" scope="row">
						{user.id}
					</MD.TableCell>
					<MD.TableCell align="left">{user.name}</MD.TableCell>
					<MD.TableCell align="left">{user.firstname}</MD.TableCell>
					<MD.TableCell align="left">{user.username}</MD.TableCell>
					<MD.TableCell align="left">{user.parent.name}</MD.TableCell>
					<MD.TableCell align="left"></MD.TableCell>
					<MD.TableCell align="left">
						<MD.Button
							color="primary"
							aria-label="rights picture"
							component="span"
							onClick={(
								event: React.MouseEvent<
									HTMLButtonElement,
									MouseEvent
								>
							) => {
								this.props.router.history.push(
									`/apps/mediaarchiver-user/${user.id}`
								);
							}}
						>
							Fetch Channels
						</MD.Button>
					</MD.TableCell>
				</MD.TableRow>
			</React.Fragment>
		);
	}
	private generateRowGroup(group: UserACL, i: number): React.ReactNode {
		const classes = this.props.classes;

		return (
			<React.Fragment key={i}>
				<MD.TableRow className={classes.row}>
					<MD.TableCell></MD.TableCell>
					<MD.TableCell component="th" scope="row">
						{group.id}
					</MD.TableCell>
					<MD.TableCell align="left">{group.name}</MD.TableCell>
					<MD.TableCell align="left">{group.firstname}</MD.TableCell>
					<MD.TableCell align="left">{group.username}</MD.TableCell>
					<MD.TableCell align="left"></MD.TableCell>
					<MD.TableCell align="left">
						<MD.Button
							color="primary"
							aria-label="rights picture"
							component="span"
							onClick={(
								event: React.MouseEvent<
									HTMLButtonElement,
									MouseEvent
								>
							) => {
								this.props.router.history.push(
									`/apps/mediaarchiver-group/${group.id}`
								);
							}}
						>
							Fetch Channels
						</MD.Button>
					</MD.TableCell>
					<MD.TableCell align="left"></MD.TableCell>
				</MD.TableRow>
			</React.Fragment>
		);
	}

	private updateGroupsInformation(index: number, group: UserACL) {
		const addedGroups = this.state.addedGroups;
		addedGroups[index] = group;
		this.setState({ addedGroups });
	}
	private updateUsersInformation(index: number, user: UserACL) {
		const addedUsers = this.state.addedUsers;
		addedUsers[index] = user;
		this.setState({ addedUsers });
	}
}

const mapStateToProps = (
	{ appsManagement, i18n, user, userManagement }: IApplicationState,
	ownProps: RouteComponentProps<IRouterMatchParams>
) => ({
	appsManagement,
	i18n: i18n.i18n,
	router: ownProps,
	user,
	userManagement,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	getACLUsers: (
		token: string,
		params: IUserSearchParams | null,
		paramsSorting: IUserSearchParamsSorting | null,
		resultsPerPage?: number,
		page?: number
	) =>
		dispatch(
			getACLUsers(token, params, paramsSorting, resultsPerPage, page)
		),
	getACLParents: (token: string, researchField: string) =>
		dispatch(getACLParents(token, researchField)),
	getAllMedias: () => dispatch(getAllMedias()),
	getGroupsAndUsersFromChannelTPP: (channelNumber: number, token: string) =>
		dispatch(getGroupsAndUsersFromChannelTPP(channelNumber, token)),
	resetMedias: () => dispatch(resetMedias()),
	addGroupChannelsTPP: (channelsID: number[], id: number) =>
		dispatch(addGroupChannelsTPP(channelsID, id)),
	addUserChannelsTPP: (channelsID: number[], id: number) =>
		dispatch(addUserChannelsTPP(channelsID, id)),
});

export const UsersAndGroupsFromChannel = connect(
	mapStateToProps,
	mapDispatchToProps
)(MD.withStyles(styles)(UsersAndGroupsFromChannelComponent));
